import { SupportedLocale } from '@insio/shared-types';
import type { SupportedLocale as GraphqlLocale } from '@/graphql';

// GraphQL enum keys (EN, CS) are the canonical stored values.
export const LOCALE_KEYS = Object.keys(SupportedLocale);

/** Whether a select value is a GraphQL locale (EN, CS). */
export const isGraphqlLocale = (value: unknown): value is GraphqlLocale =>
  typeof value === 'string' && Object.hasOwn(SupportedLocale, value);
